import React from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { DialogAriaWrapper } from '@juno/ui';

interface RestrictCourseEnrollDialogProps {
  handleClose: () => void;
  handleUpgrade: (url: string) => void;
  upgradeUrl?: string;
}

const RestrictCourseEnrollDialog: React.FC<RestrictCourseEnrollDialogProps> = ({
  handleClose,
  handleUpgrade,
  upgradeUrl,
}) => {
  return (
    <DialogAriaWrapper id='restrict-course-enroll-dialog' open={true}>
      <DialogTitle
        sx={{
          width: 600,
          textAlign: 'center',
          justifyContent: 'center',
          display: 'flex',
          mx: 'auto',
        }}
      >
        <Typography variant='h6'>{upgradeUrl ? 'Premium Content' : 'Exclusive Content'}</Typography>
      </DialogTitle>
      <Divider sx={{ mx: 2 }} />
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          textAlign: 'center',
          width: 600,
          minHeight: 150,
          mx: 'auto',
        }}
      >
        <DialogContentText variant='subtitle1' component='div'>
          {upgradeUrl
            ? 'Registration is required to access this course.'
            : 'This course is a part of our exclusive collection.'}
        </DialogContentText>
        <DialogContentText variant='body2' component='div'>
          {upgradeUrl
            ? 'Please click the registration button below for more information and to sign-up.'
            : 'Public registration is not available at this time.'}
        </DialogContentText>
      </DialogContent>
      <Divider sx={{ mx: 2 }} />
      <DialogActions sx={{ p: 2, display: 'flex', gap: 2 }}>
        {upgradeUrl ? (
          <>
            <Button
              aria-label='register'
              variant='contained'
              onClick={() => handleUpgrade(upgradeUrl as string)}
              fullWidth
            >
              Register
            </Button>
            <Button aria-label='cancel' variant='outlined' onClick={handleClose} fullWidth>
              Cancel
            </Button>
          </>
        ) : (
          <Button aria-label='i-understand' variant='contained' onClick={handleClose} fullWidth>
            I Understand
          </Button>
        )}
      </DialogActions>
    </DialogAriaWrapper>
  );
};

export default RestrictCourseEnrollDialog;
